<template>
  <div style="width: 100%;height: 100%;">
    <div style="width: 100%;display: flex;">
      <div style=" width: 80%;height: 40px;">
        <el-row style="margin:10px;width: 95%;display: flex;padding-left: 20px;">
          <el-select size="small" style="width: 140px;" @change="partserch" v-model="formDatas.logPlatform" clearable
            placeholder="请选择平台">
            <el-option label="pc" :value="1" key="1">
            </el-option>
            <el-option label="wx" :value="2" key="2">
            </el-option>
          </el-select>
          <el-input v-model="formDatas.logUserName" style="width: 130px" size="small" placeholder="请输入名字"></el-input>
          <el-input v-model="formDatas.logApi" style="width: 130px" size="small" placeholder="请输入接口名"></el-input>
          <el-select size="small" style="width: 140px;" @change="partserch" v-model="formDatas.logType" clearable
            placeholder="请选择类型">
            <el-option label="查询" :value="1" key="1">
            </el-option>
            <el-option label="新增" :value="2" key="2">
            </el-option>
            <el-option label="编辑" :value="3" key="3">
            </el-option>
            <el-option label="删除" :value="4" key="4">
            </el-option>
          </el-select>

          <el-button type="danger" size="small" icon="el-icon-search" @click="partserch"
            style="margin-left: 10px;">搜索</el-button>

        </el-row>
      </div>
      <div style=" width: 40%;height: 40px;">
        <el-row style="margin:10px;width: 95%;display: flex;flex-direction: row-reverse;">

        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss">
        <el-table ref="multipleTable" :data="tableData" stripe border style="width: 100%" :max-height="tableHight"
          :cell-style="{ textAlign: 'center' }" :header-cell-style="{
            textAlign: 'center',
            background: 'rgba(0,170,255,0.5)',
            color: 'black',
            border: 'none'
          }" @selection-change="handleSelectionChange">

          <el-table-column type="selection" width="55" fixed="left">
          </el-table-column>



          <el-table-column type="index" label="序号" width="50" fixed="left">
          </el-table-column>
          <el-table-column prop="logPlatform" label="类型" width="70">
            <template slot-scope="scope">
              <div type="text" style="color:#409EFF ;font-size: 12px;">
                {{ scope.row.logPlatform == 1 ? 'pc' : 'wx'
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="logType" label="类型" width="70">
            <template slot-scope="scope">
              <div type="text" style="color:#409EFF ;font-size: 12px;">
                {{ scope.row.logType == 1 ? '查询' : scope.row.logType == 2 ? '新增' : scope.row.logType == 3 ? '编辑' : '删除'
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="logApi" label="接口名">
          </el-table-column>
          <el-table-column prop="logPath" label="接口地址">
          </el-table-column>
          <el-table-column prop="description" label="接口具体类型">
          </el-table-column>
          <el-table-column prop="logIp" label="ip地址">
          </el-table-column>
            <el-table-column prop="logParams" label="携带参数" width="350">
          </el-table-column>
          <el-table-column prop="logUserName" label="操作人员">
          </el-table-column>
          <el-table-column prop="logTime" label="操作时间">
          </el-table-column>
        </el-table>
      </div>

      <div style="width: 100%;height: 60px">
        <div style="width: 100%;height: 100%;margin-top: 10px;">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :page-sizes="[20, 50, 80, 100, 300, 500, 1000]" background layout="total,sizes,prev, pager, next "
            :page-size="20" :total="totals" :current-page="currentPage">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let Base64 = require('js-base64').Base64
import qs from "qs";
// import api from "../../utils/api";
import {

  getSysLogList, //获取执行中心

} from "../../api/api";
export default {
  name: 'SystemLog',
  data() {
    return {
      LookTeacherDetail: false,
      TeacherDetForm: {},
      sitId: '',//导入暂存id
      TemstrongArr: [],
      tableHight: 520,
      importData: '',
      diatextfj: false,
      isDelfj: false,
      noneBtnDealImgfj: false,
      dialogImageUrlfj: '',
      filenamefj: "",

      loadings: "",
      bulkData: [],
      bulkImport: false,
      post: localStorage.getItem('post'),
      ids: [],
      atidsArr: [],
      currentPage: 1,
      totals: null,
      formDatas: {
        logType: '',
        logApi: '',
        currentPage: 1,
        pageSize: 20,
      },

      teacherdata: '',
      projectdata: '',
      formtext: {
        aqpPic: '',
      },
      formtexts: {
        aeFile: '',
      },
      diatext: false, //附件弹框
      isDel: false, //附件弹框上传1
      noneBtnDealImg: false, //附件弹框上传1

      dialogImageUrlFP: '',


      tableData: [],
      dialog: false, //弹框
      loading: false,
      timer: null,
      form: {
        aeLeaseStartDate: '',
        aeLeaseEndDate: '',
        aeCity: '',
        aeAddress: '',
        aeContact: '',
      },
      diashow: false, //关闭
      expid: 0,
      edit: false, //编辑时
      dialogImageUrl: '', //预览图片地址
      dialogVisible: false,
      disabled: false,
      watchFlag: false,
    }
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.tableHight = window.innerHeight - 200 - (window.innerHeight * 0.04)
      })();
    };
  },
  methods: {










    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.formDatas.pageSize = val;
      this.getSysLogList()
    },









    // 多选时对ids的操作
    handleSelectionChange(val) {
      if (this.ids.length > val.length) {

        this.ids.forEach((d, indx) => {

          this.tableData.forEach((ta, le) => {
            if (val.length == 0 && ta.aeId == d.aeId) {
              this.atidsArr.forEach((t, n) => {
                if (d.aeId === t.aeId) {
                  this.atidsArr.splice(n, 1)
                  console.log('一个也不选的时候', this.atidsArr)
                }
              })
            }
          })
          val.forEach(a => {
            if (d.aeId != a.aeId) {
              this.atidsArr.forEach((t, n) => {
                if (d.aeId === t.aeId) {
                  this.atidsArr.splice(n, 1)
                  console.log('取消时候', this.atidsArr)
                }
              })

            } else { }
          })
        })
      }
      this.ids = val
      this.ids.forEach(item => {
        console.log(item)
        this.atidsArr.push(item)
      })
      for (var i = 0; i < this.atidsArr.length; i++) {
        for (var j = i + 1; j < this.atidsArr.length; j++) {
          if (this.atidsArr[i].aeId === this.atidsArr[j].aeId) {

            this.atidsArr.splice(i, 1)
          }
        }
      }
      console.log(' 选择了', this.ids)
      console.log(' push进去', this.atidsArr)
    },



    // 上传预览
    handlePictureCardPreview(file) {
      console.log("预览了")
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 分页跳转
    async handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.formDatas.currentPage = val;
      const s = qs.stringify(this.formDatas)

      await getSysLogList(s).then(res => {
        this.totals = res.total
        this.tableData = res.data
        this.$nextTick(() => {
          console.log('最后的ids', this.atidsArr)
          this.tableData.forEach((i, index) => {
            this.atidsArr.forEach(t => {
              if (i.aeId === t.aeId) {
                this.$refs.multipleTable.toggleRowSelection(i, true);
              }
            })
          })
        })
      })
    },

    closeSizer() {

      this.formDatas = {
        logType: '',
        logApi: '',
        currentPage: 1,
        pageSize: 20,
      }
      this.expid = 0

    },
    partserch() {
      this.formDatas.currentPage = 1
      this.currentPage = this.formDatas.currentPage
      const s = qs.stringify(this.formDatas)
      getSysLogList(s).then(res => {
        this.tableData = res.data
        this.totals = res.total
        // this.$message({
        //   type: 'success',
        //   message: '搜索成功!'
        // });
      })
    },
    previewImg(val) {
      console.log(val);
      window.open('https://filepreview.aojuai.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(
        val))); //base64Encode(url)
    },

    // 取消附加上传
    closeSubmitText() {
      this.$confirm('是否取消上传该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.diatext = false
        this.isDel = false;

        this.noneBtnDealImg = false
        this.formtext = {
          aqpPic: '',
        }
        this.$refs.upload.clearFiles();
        this.$message({
          type: 'success',
          message: '取消成功!'
        });


      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 上传附件
    onSubmit() {
      this.$confirm('此操作将上传该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        if (this.formtext.aqpPic == '') {
          this.$message({
            type: 'danger',
            message: '请先上传附件!'
          });
        } else {
          const s = qs.stringify(this.formtext);
          updateAvQualificationsPublicPic(s).then(res => {
            this.$message({
              type: 'success',
              message: '上传成功!'
            });
            this.$refs.upload.clearFiles();
            this.$nextTick(() => {
              this.getSysLogList()
              this.diatext = false
              this.isDel = false;
              this.noneBtnDealImg = false
              this.formtext = {
                aqpPic: '',
              }
            });

          })
        }

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },




    // 上传附件


    uploadAffix(data, val) {
      if (val == 1) {
        this.diatext = true;
        this.isDel = false;
        this.noneBtnDealImg = false
        this.dialogImageUrlFP = '';
        this.formtext.aeId = data;
      } else {
        this.diatext = true;
        const ap = JSON.parse(JSON.stringify(data))
        this.isDel = true;
        this.dialogImageUrlFP = ap.aqpPic;
        this.noneBtnDealImg = true
        this.formtext.aeId = ap.aeId
        this.formtext.aqpPic = ap.aqpPic

      }
    },
    async updataProve(file, fileList, val) {
      let Data = new FormData();
      Data.append('file', file.raw)
      this.noneBtnDealImg = true;

      await uploadFileLocal(Data).then(res => {
        console.log("上传成功")
        this.formtext.aqpPic = res.data
      })

    },
    async updataProve2(file, fileList, val) {
      this.TemstrongArr = [];
      let Data = new FormData();
      Data.append('file', file.raw)
      await uploadApExecution(Data).then(res => {
        console.log("上传成功")
        this.bulkData = res.data.data.resultList;
        this.importData = res.data.data.importData;
        this.sitId = res.data.data.sysImportTem.sitId;
        if (res.data.data.importData.numSuccess > 0 && res.data.data.importData.numSuccess != res.data.data.importData.numUnWhole) {
          this.TemstrongArr.push({ text: '成功', value: '成功' })
        }
        if (res.data.data.importData.numFail > 0) {
          this.TemstrongArr.push({ text: '失败', value: '失败' })
        }
        if (res.data.data.importData.numUnWhole > 0 && res.data.data.importData.numUnWhole != null) {
          this.TemstrongArr.push({ text: '信息不完整', value: '信息不完整' })
        }

        if (res.data.data.status == "成功") {
          this.$nextTick(() => {
            this.getSysLogList()
          })
        }

      })

    },

    // 编辑
    handleEdit(index, row) {
      console.log(index, row);
      this.edit = true;
      this.dialog = true;
      const data = JSON.parse(JSON.stringify(row))
      this.form = data
    },
    // 删除
    async handleDelete(index, row) {
      this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const s = qs.stringify({
          aeId: row.aeId
        })
        deleteApExecution(s).then(res => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          });
          this.$nextTick(() => {
            this.getSysLogList()
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      console.log(index, row);
    },
    // 获取列表
    async getSysLogList() {
      // this.formDatas.currentPage = this.currentPage
      const s = qs.stringify(this.formDatas)
      await getSysLogList(s).then(res => {
        this.tableData = res.data
        this.totals = res.total
      })

    },
    open() {
      if (this.form.aqName == '') {
        this.$message({
          showClose: true,
          message: '请填写证书名称',
          type: 'success'
        });
      } else {

        this.diashow = true
        this.$refs.drawer.closeDrawer()
      }

    },
    async handleClose(done) {
      console.log(this.diashow)
      if (this.diashow == false) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
            this.form = {
              aeLeaseStartDate: '',
              aeLeaseEndDate: '',
              aeCity: '',
              aeAddress: '',
              aeContact: '',

            }
            this.edit = false
            this.diashow = false
          })
          .catch(_ => { });


      } else {
        console.log(this.diashow)
        // 表单编辑
        if (this.edit == true) {
          this.$confirm('确定要编辑？')
            .then(_ => {
              const s = qs.stringify(this.form)
              updateApExecution(s).then(res => {
                if (!res) return
                this.$message({
                  showClose: true,
                  message: '编辑成功',
                  type: 'success'
                });
                this.$nextTick(() => {
                  this.getSysLogList()
                })
                this.form = {
                  aeLeaseStartDate: '',
                  aeLeaseEndDate: '',
                  aeCity: '',
                  aeAddress: '',
                  aeContact: '',
                },

                  this.edit = false
                // this.loading = true;
                done();
              })


            })
            .catch(_ => { });
          this.diashow = false
        } else {
          // 表单提交
          this.$confirm('确定要提交表单吗？')
            .then(_ => {
              const s = qs.stringify(this.form)
              addApExecution(s).then(res => {
                if (!res) return
                this.$message({
                  showClose: true,
                  message: '新增成功',
                  type: 'success'
                });
                this.$nextTick(() => {
                  this.getSysLogList()
                })
                this.form = {
                  aeLeaseStartDate: '',
                  aeLeaseEndDate: '',
                  aeCity: '',
                  aeAddress: '',
                  aeContact: '',
                },
                  // this.loading = true;
                  done();
                this.diashow = false
              })

              // this.timer = setTimeout(() => {


              //   // 动画关闭需要一定的时间
              //   setTimeout(() => {
              //     this.loading = false;
              //   }, 400);
              // }, 2000)
            })
            .catch(_ => { });

        }
      }
    },
    // 表单取消
    cancelForm() {
      this.form = {
        aeLeaseStartDate: '',
        aeLeaseEndDate: '',
        aeCity: '',
        aeAddress: '',
        aeContact: '',
      },
        this.edit = false
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    }
  },
  activated() {
    this.$nextTick(() => {
      console.log("激活 ")
      this.getSysLogList()
    })
  },
  async created() {

    this.windheight = this.$store.state.windheight
    this.tableHight = this.windheight - 200 - this.windheight * 0.04;

    this.getSysLogList()
  }
}
</script>

<style scoped>
.disUoloadSty /deep/ .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}

.imgPreview {
  width: 40px;
  height: 40px;
  border-radius: 0 0 0 100%;

}

.tablecss {
  padding: 15px;
  /* height: 740px; */
  overflow-y: hidden;
}

div /deep/ .el-checkbox__label {
  font-size: 18px;
}

div /deep/ .el-pagination__total {
  margin-right: 35%;
  margin-left: 5%;
}

#mask_layer {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: calc(100% - 60px);
}
</style>